<template>
  <div
    class="fe-flex fe-items-center fe-gap-xxs fe-py-xs fe-cursor-pointer"
    @click="moveToReviewBinding"
  >
    <div>
      <StarRating
        :readOnly="true"
        :initialRating="averageRating"
        :partialSupport="true"
        maxStars="1"
        size="m"
      />
    </div>
    <div v-if="currentVertical.rd" class="fe-text-body-s-bold">
      {{ averageRating }}
    </div>
    <div class="fe-text-body-s fe-text-primary-grey-80">
      ({{ totalRatingCount }} Ratings & {{ totalReviewCount }} Review)
    </div>
  </div>
</template>

<script>
  import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import {
    BINDING_ELEMENT_ID,
    FYND_DEFAULT_HEADER_CLASSNAME,
  } from "@/constants/constants"
  import { checkCurrentVerticals } from "@/utils/utils"

  export default {
    name: "AverageRating",
    components: { StarRating },
    inject: ["globalState"],
    computed: {
      averageRating() {
        return this.globalState.avgRating || 0
      },
      totalRatingCount() {
        return this.globalState.ratingsCount || 0
      },
      totalReviewCount() {
        return this.globalState.reviewsCount || 0
      },
      currentVertical() {
        return checkCurrentVerticals()
      },
    },
    methods: {
      moveToReviewBinding() {
        const element = document.getElementById(
          BINDING_ELEMENT_ID.REVIEW_AND_RATING,
        )

        if (!element) return

        // Get the bounding rectangle of the target element
        const elementRect = element.getBoundingClientRect()

        // Get the Fixed/Sticky positioned Header offset height
        const headerElementHeight =
          document.querySelector(`.${FYND_DEFAULT_HEADER_CLASSNAME}`)
            ?.offsetHeight || 0

        const elementScrollPosition =
          window.scrollY + elementRect.top - headerElementHeight

        // Scroll to the calculated element position
        window.scrollTo({
          top: elementScrollPosition,
          behavior: "smooth",
        })
      },
    },
  }
</script>
